/**
 * KDS Switch — Kintsugi Design System node 20:664.
 *
 * KDS size labels map to Chakra `size` values used by org/admin/partner call sites
 * so follow-on migration is an import swap (no prop renames).
 *
 * | KDS    | `size` | Track (W × H) | Thumb (Ø) |
 * | ------ | ------ | ------------- | --------- |
 * | Small  | `sm`   | 26 × 16 px    | 12 px     |
 * | Medium | `md`   | 34 × 20 px    | 16 px     |
 * | Large  | `lg`   | 50 × 28 px    | 24 px     |
 *
 * Track colors are fixed in the recipe (off: neutral.250, on: brand.500; disabled uses 60% opacity) — not a `colorPalette` axis.
 * Thumb: neutral.50 (default), neutral.200 (disabled).
 */
export const switchTrackWidth = {
  sm: '26px',
  md: '34px',
  lg: '50px',
} as const;

export const switchTrackHeight = {
  sm: '16px',
  md: '20px',
  lg: '28px',
} as const;

/** Thumb diameter per size (Figma circle radius × 2). Applied via Chakra thumb `scale` relative to track height. */
export const switchThumbScale = {
  sm: 12 / 16,
  md: 16 / 20,
  lg: 24 / 28,
} as const;

export type SwitchSize = keyof typeof switchTrackWidth;

export const switchSizes = Object.keys(switchTrackWidth) as SwitchSize[];
